const invertedMessages = {
  'Welcome to ID Proofing': 'external.anonymous.text.welcome',
  'To begin the ID proofing process, you will be securely redirected to Identity Proofing website to complete your identity verification.':
    'external.anonymous.text.subText',
  'Start ID Proofing': 'external.anonymous.start',
  'Start ID Proofing on IDDataweb': 'external.anonymous.start.btn',
};

export default invertedMessages;
